<div class="page">
  <div fxLayout="row">
    <div fxFlex="80" class="blog-post-container">
      <app-blog-post-list
        [posts]="posts$ | async">
      </app-blog-post-list>
    </div>
    <div fxFlex="20" class="archive-list-container">
      <app-archive-list
        [posts]="posts$ | async">
      </app-archive-list>
    </div>
  </div>
  <button mat-raised-button (click)="createBlogPost()">Create Blog Post</button>
  <div [formGroup]="blogForm">
    <mat-form-field appearance="outline">
      <mat-label>Blog Title</mat-label>
      <input matInput formControlName="title">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Blog Sub-Title</mat-label>
      <input matInput formControlName="subtitle">
    </mat-form-field>
    <quill-editor formControlName="body"></quill-editor>
  </div>
</div>